import { faClose } from '@fortawesome/sharp-solid-svg-icons';
import type { FC } from 'react';

import { CardIconButton } from '@/features/selectionsPanel/selectionCard/baseCard/cardIconButton';

type Props = {
  onClick: () => void;
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

export const CardCloseButton: FC<Props> = ({
  onClick,
  className = '',
  onMouseEnter = () => {},
  onMouseLeave = () => {},
}) => {
  return (
    <CardIconButton
      className={className}
      icon={faClose}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
